// Common types for both frontend and backend
// Default values for payment methods
export const DEFAULT_PAYMENT_METHODS = {
    bank: {
        iban: '',
        bic: '',
        accountName: '',
        enabled: false
    },
    paypal: {
        email: '',
        enabled: false
    },
    mollie: {
        apiKey: '',
        description: 'Invoice {invoiceNumber}',
        enabled: false
    },
    stripe: {
        accountId: '',
        description: 'Invoice {invoiceNumber}',
        enabled: false
    }
};
//# sourceMappingURL=index.js.map